export default "__VITE_ASSET__RJvXuaUV6a0JYddfOv$nwA__"